import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';

import { ProjectTeamChangeRequest } from '../types';
import { WithUsers } from '../../users';
import { Team } from '../../teams';

type ActiveTeamChangeRequest = Omit<
  WithUsers<ProjectTeamChangeRequest, 'requestedBy'>,
  'fromTeam'
> & {
  fromTeam: Team;
};

export const projectTeamLoaders = getLoaders({
  getTeamChangeRequest: {
    load: async (payload: {
      projectId: string;
      requestId: string;
    }): Promise<WithUsers<ProjectTeamChangeRequest, 'requestedBy'>> => {
      return executeApiCall({
        path: `/projects/team-change`,

        method: 'get',

        payload,
      });
    },
  },

  activeTeamChangeRequests: {
    load: async (): Promise<ActiveTeamChangeRequest[]> => {
      return executeApiCall({
        path: `/projects/team-change/active`,

        method: 'get',
      });
    },
  },
});
